import { put } from 'redux-saga/effects';
import { actions } from 'react-redux-form';

export function* attendInsuranceCooperationUserDataFailureSaga() {
  yield put(actions.setPending('entities.forms.login', false));
  yield put(actions.setPending('entities.forms.user', false));
}
